import type { IAvailablePaymentMethodsResponse } from '../../interfaces';

import { PaymentMethod } from './components/payment-method';
import PaymentMethodTitle from './components/title/payment-method-title';

type WalletsProps = {
  wallets: IAvailablePaymentMethodsResponse['wallets'];
};

export const Wallets = ({ wallets }: WalletsProps) => {
  if (!wallets?.length) return null;
  return (
    <div className="co-flex co-flex-col co-gap-24px">
      <PaymentMethodTitle title={'Billetera digital'} />
      {wallets?.map((paymentMethod, index) => {
        return (
          <PaymentMethod
            paymentMethod={paymentMethod}
            accordionIndex={0}
            index={index}
            key={index}
          />
        );
      })}
    </div>
  );
};
